import axios from "axios";
import authHeader from "services/auth-header";

class OnDemandService {
  getStatus(params) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `teleconsult_on_demands/on_demand_status`,
        { headers: authHeader(), params: params }
      )
      .then((response) => {
        return response.data;
      });
  }
  updateStatus(params) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `teleconsult_on_demands/update_status`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  accept(params) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `teleconsult_on_demands/${params.id}/accept`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  end(params){
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `teleconsult_on_demands/${params.id}/end`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      }); 
  }
  getDetails(params){
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `teleconsult_on_demands//${params.id}`,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new OnDemandService();
